import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

const RouteTracker = () => {
  const location = useLocation();
  const prevPath = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath !== prevPath.current) {
      trackPageView(currentPath, prevPath.current);
      prevPath.current = currentPath;
    }
  }, [location]);

  return null;
};

export default RouteTracker;
